import React, { useState, useEffect } from 'react';
import axios from 'axios';

const RoleModal = ({ show, onHide, role, onSuccess, onError }) => {
  const [roleForm, setRoleForm] = useState({
    role_name: '',
    description: '',
    is_active: true
  });
  const [loading, setLoading] = useState(false);

  const API_BASE = process.env.REACT_APP_API_BASE;

  useEffect(() => {
    if (role) {
      setRoleForm({
        role_name: role.role_name,
        description: role.description,
        is_active: role.is_active
      });
    } else {
      setRoleForm({
        role_name: '',
        description: '',
        is_active: true
      });
    }
  }, [role]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('authToken');
      const isUpdate = !!role;
      
      const requestData = isUpdate 
        ? { ...roleForm, role_id: role.role_id }
        : roleForm;

      const response = await axios.post(`${API_BASE}/create_role.php`, 
        requestData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        onSuccess();
      } else {
        onError(response.data.error || `Failed to ${isUpdate ? 'update' : 'create'} role`);
      }
    } catch (error) {
      onError(error.response?.data?.error || `Failed to ${role ? 'update' : 'create'} role`);
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow">
          <div className="modal-header bg-info text-white">
            <h5 className="modal-title">
              <i className="bi bi-people me-2"></i>
              {role ? 'Edit Role' : 'Add New Role'}
            </h5>
            <button 
              type="button" 
              className="btn-close btn-close-white" 
              onClick={onHide}
              disabled={loading}
            ></button>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row g-3">
                {role && (
                  <div className="col-12">
                    <label className="form-label">Role ID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={role.role_id}
                      disabled
                    />
                    <div className="form-text">Role ID cannot be changed</div>
                  </div>
                )}
                <div className="col-12">
                  <label className="form-label">Role Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    value={roleForm.role_name}
                    onChange={(e) => setRoleForm({...roleForm, role_name: e.target.value})}
                    required
                    disabled={loading}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={roleForm.description}
                    onChange={(e) => setRoleForm({...roleForm, description: e.target.value})}
                    disabled={loading}
                  />
                </div>
                <div className="col-12">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={roleForm.is_active}
                      onChange={(e) => setRoleForm({...roleForm, is_active: e.target.checked})}
                      disabled={loading}
                    />
                    <label className="form-check-label">Active Role</label>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={onHide}
                disabled={loading}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="btn btn-info"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    {role ? 'Updating...' : 'Creating...'}
                  </>
                ) : (
                  role ? 'Update Role' : 'Create Role'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RoleModal;